import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { getBootstrapConfig } from './app/bootstrap.config';
import { assetCdnUrlFactory } from './app/state/app-config/factories/asset-cdn-url.factory';
import { environmentFactory } from './app/state/app-config/factories/environment.factory';
import { isEpiserverFactory } from './app/state/app-config/factories/is-episerver.factory';
import { webpackPublicPathFactory } from './app/state/app-config/factories/webpack-public-path.factory';
import { cultureCodeFactory } from './app/state/culture/initializer/culture-code.initializer';
import { enforceTrailingSlashes } from './app/state/routing/trailing-slash.initializer';
import { environment as env } from './environments/environment';

declare const module: {
    hot?: {
        accept: () => void;
        dispose: (cb: () => void) => void;
    };
};

const assetCdnUrl = assetCdnUrlFactory();
const cultureCode = cultureCodeFactory(window);
const environment = environmentFactory(document);
const isEmbedded = isEpiserverFactory(document);

if (environment === 'prod') {
    enableProdMode();
}

if (isEmbedded) {
    enforceTrailingSlashes();
    __webpack_public_path__ = webpackPublicPathFactory(
        assetCdnUrl,
        environment,
        cultureCode
    );
}

// TODO: remove this after 2025-08-10
sessionStorage.removeItem('appConfig');

getBootstrapConfig(assetCdnUrl, cultureCode, environment, isEmbedded)
    .then((bootstrapConfig) => {
        if (environment !== 'prod' && environment !== 'local') {
            Sentry.init({
                debug: true,
                dsn: 'https://14c07e9bfa019cfe5466e3f4af033ee1@o4506951084998656.ingest.us.sentry.io/4507097800441856',
                environment,
                integrations: [Sentry.browserTracingIntegration()],
                release: env.version,
                replaysSessionSampleRate: 0.1,
                tracesSampleRate: 0.1,
            });
        }

        if (env.hmr && module['hot']) {
            module['hot'].accept();
            module['hot'].dispose(() => {
                const oldRootElem = document.querySelector('rdx-root');
                const rootElemParent = oldRootElem?.parentNode;
                if (oldRootElem && rootElemParent) {
                    rootElemParent.removeChild(oldRootElem);
                    rootElemParent.appendChild(
                        document.createElement('rdx-root')
                    );
                }
            });
        }

        bootstrapApplication(AppComponent, bootstrapConfig).catch(
            (err: unknown) => {
                console.error(err);
            }
        );
    })
    .catch((err: unknown) => {
        console.error(err);
    });
